import { BoxProps, Tag, Text } from "@chakra-ui/react";
import React, { useMemo } from "react";

import { useCustomBreakpoints } from "hooks/useCustomBreakpoints";
import { IPrintNumbers } from "state/artworks";

type VariantType = "normal" | "verbal" | "verbal-chip";
export interface SupplyDetailsProps extends BoxProps, IPrintNumbers {
  variant?: VariantType;
}

export const SupplyDetails: React.FC<SupplyDetailsProps> = ({
  edition,
  maxSupply,
  supply,
  variant = "normal",
  ...rest
}) => {
  const { smUp } = useCustomBreakpoints();
  const displayedTitle = useMemo(() => {
    if (typeof supply === "undefined") return;
    if (edition) {
      return formatSupply(variant, edition, supply);
    }
    if (maxSupply === undefined) {
      return "Unlimited";
    }
    return formatSupply(variant, supply, maxSupply);
  }, [edition, maxSupply, supply, variant]);

  switch (variant) {
    case "normal":
      return (
        <Text fontWeight="bold" {...rest}>
          {displayedTitle}
        </Text>
      );
    case "verbal":
      return (
        <Text flexShrink={0} variant={smUp ? "subtitle" : "small"} {...rest}>
          {displayedTitle}
        </Text>
      );
    case "verbal-chip":
      return (
        <Tag {...rest} px={smUp ? 4 : 3}>
          <Text variant={smUp ? "subtitle" : "small"}>{displayedTitle}</Text>
        </Tag>
      );
  }
};

const formatSupply = (variant: VariantType, first: number, second: number) => {
  const _first = Math.max(first, 1);
  const _second = Math.max(second, 1);
  switch (variant) {
    case "verbal":
    case "verbal-chip":
      return `${_first} of ${_second}`;
    default:
      return `${_first} / ${_second}`;
  }
};
